import React from "react";
import aboutimg from "../images/profilebg.png";
import arrow from "../images/arrow.png";
import { TypeAnimation } from "react-type-animation";
import "../style/about.css";

const About = () => {
  return (
    <>
      <div className="about-main" id="about">
        <div className="type2"></div>

        <div className="about-container">
          <div className="about-grid2">
            <div
              className="about-detail"
              data-aos="fade-right"
              data-aos-duration="800"
            >
              <p>
                I'm a full-stack Software Engineer working with React.js,
                Next.js, Node.js, and NestJS, and building toward AI
                engineering. I have hands-on experience integrating AI systems
                into production — including AI job pipelines that enqueue, poll,
                and persist AI-generated content, and a Model Context Protocol
                (MCP) server that exposes live PostgreSQL data to AI agents. I
                have a strong foundation in MySQL and PostgreSQL, REST API
                design, OAuth-based authentication, and cloud deployment on AWS.
                From feature development through deployment, I focus on
                scalable, reliable systems that meet real product needs. Let's
                collaborate to bring your project to life!
              </p>
            </div>
            <div className="typeo">
            <TypeAnimation
              sequence={[
                "Full Stack Developer",
                1650,
                "AI Engineer",
                1100,
              ]}
              wrapper="span"
              speed={50}
              style={{ fontSize: "1.5em", display: "inline-block" }}
              repeat={3}
            />
          </div>
          </div>
          <div className="arrowimg" data-aos="fade-down-right">
            <img src={arrow} alt="" />
          </div>
          <div
            className="about-img about-grid1"
          >
          <div className="typeo">
            <TypeAnimation
              sequence={[
                "AI Engineer",
                1100,
                "Full Stack Developer",
                1650,
              ]}
              wrapper="span"
              speed={50}
              style={{ fontSize: "1.5em", display: "inline-block" }}
              repeat={3}
            />
            </div>
            <div className="about_img"   data-aos="fade-left"
            data-aos-anchor-placement="center-bottom"
            data-aos-duration="800">
            <img src={aboutimg} alt="" />
            </div>
            </div>
        </div>
      </div>
    </>
  );
};

export default About;
